import { toast } from 'react-hot-toast';
import CrossIcon from 'src/assets/images/icons/default/XmarkWhite';
import Button from 'src/components/Button/Button';
import { ButtonMode } from 'src/components/Button/button-mode.enum';
import { ButtonSize } from 'src/components/Button/button-size.enum';
import { ButtonType } from 'src/components/Button/button-type.enum';
import { ToastStatusProps } from 'src/components/Toast/toast-status-prop.enum';
import { ToastType } from 'src/components/Toast/toast-type.enum';

/**
 * Function to show a custom toast.
 * Displays a toast notification with predefined styles based on the toast type.
 *
 * @param {string} message - The message to display in the toast.
 * @param {ToastType} [type=ToastType.Success] - The type of the toast (Success, Error, etc.). Defaults to Success.
 */

export const showToast = (message: string, type: ToastType = ToastType.Success) => {
  const { borderColor, backgroundColor, icon } = ToastStatusProps[type];

  const toastId = toast(
    <div
      className={`w-full min-w-0 md:w-[340px] py-2 pr-2 pl-4 rounded-[12px] border ${borderColor} ${backgroundColor}`}
    >
      <div className="flex items-center gap-2 w-full min-w-0">
        <div className="w-4 h-4 shrink-0">{icon}</div>
        <span className="text-body-p2-medium font-medium text-start text-content-neutral-default-enabled flex-1 min-w-0 break-words">
          {message}
        </span>
        <div className="flex items-center justify-center shrink-0">
          <Button
            icon={<CrossIcon className="w-4 h-4" />}
            size={ButtonSize.Small}
            mode={ButtonMode.OnDark}
            type={ButtonType.Ghost}
            className="w-8 h-8"
            onClick={() => toast.dismiss(toastId)}
            iconOnly
          />
        </div>
      </div>
    </div>
  );
};
